import { Controller } from "@hotwired/stimulus"
import { Sortable } from "sortablejs"

export default class extends Controller {
  static targets = ["list"]
  static values = { url: String }

  connect() {
    console.log("Sortable controller connected")
    this.sortable = Sortable.create(this.listTarget, {
      handle: ".bi-grip-vertical",
      animation: 150,
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      dragClass: "sortable-drag",
      onEnd: this.updateOrder.bind(this)
    })
    console.log("Sortable initialized")
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  async updateOrder(event) {
    console.log("Update order called")
    const items = Array.from(this.listTarget.children)
    
    // Detekce typu entity podle data atributu
    let ids, paramKey, entityName
    if (items[0]?.dataset.pageId) {
      ids = items.map(item => item.dataset.pageId)
      paramKey = 'page_ids'
      entityName = 'stránek'
    } else if (items[0]?.dataset.categoryId) {
      ids = items.map(item => item.dataset.categoryId)
      paramKey = 'category_ids'
      entityName = 'kategorií'
    } else {
      console.error("Unknown entity type")
      return
    }
    
    console.log(`${entityName} IDs:`, ids)
    
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ [paramKey]: ids })
      })

      if (!response.ok) {
        throw new Error("Failed to update order")
      }

      // Show success message
      this.showMessage(`Pořadí ${entityName} bylo úspěšně aktualizováno`, "success")
    } catch (error) {
      console.error("Error updating order:", error)
      this.showMessage("Chyba při aktualizaci pořadí", "error")
      // Revert the order
      this.sortable.sort(ids)
    }
  }

  showMessage(message, type) {
    // Create a temporary alert
    const alertClass = type === "success" ? "alert-success" : "alert-danger"
    const alert = document.createElement("div")
    alert.className = `alert ${alertClass} alert-dismissible fade show`
    alert.innerHTML = `
      ${message}
      <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    `
    
    // Insert at the top of the content
    const container = document.querySelector(".container-fluid")
    container.insertBefore(alert, container.firstChild)
    
    // Auto-dismiss after 3 seconds
    setTimeout(() => {
      if (alert.parentNode) {
        alert.remove()
      }
    }, 3000)
  }
}
